import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/org',
        name: 'org',
		subheader: languages.org.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "10",
            icon: "apartment",
        },
        component: PageAll,
		children: [
			{
				path: '/org',
				name: 'org',
				component: resolve => require(['@/pages/org/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.org.title1,
					permCode: "1001",
				},
			}
		]
    },
]
  